import React from "react";
import Navbar from "../components/Navbar";
import "../styles/global.css";
import Subcategory from "../components/Subcategory";
import Footer from "../components/Footer";
import { useParams } from "react-router";
import { Helmet } from "react-helmet-async";
import seoFriendlySlug from "../utils/seoFriendlySlug";

const SubCategoryPage = () => {
  const { category, subcategory } = useParams();

  const baggageScannerKewords = [
    "security checking machine name",
    "security machine",
    "metal detector scan",
    "x ray scanner online",
    "baggage scanner",
    "x ray baggage scanner",
    "bag scanner",
    "baggage scanner machine",
    "baggage x ray machine",
    "x ray baggage scanner manufacturers india",
    "x ray baggage scanner manufacturers",
    "airport baggage scanner",
    "x ray baggage inspection system",
    "baggage scanner machine price",
    "security check machine",
    "security scanner machine",
    "bag scanning machine",
    "bag checking machine",
    "baggage scanner machine colour code",
    "x ray scanner machine",
    "baggage scanner colour code",
    "xbis machine",
    "explosive detector",
    "vision xray machine",
    "x ray scanner application",
    "x ray scanner",
    "airport x ray machine",
    "scanner machine",
    "airport scanning machine",
    "x bis",
    "x ray cloth scanner",
    "airport x ray scanner",
    "x ray wall scanner",
    "scanner machine price in india",
    "x ray scanner for walls",
    "scanning machine images",
    "baggage images",
    "parcel scanner",
    "baggage scanner colour code pdf",
  ];
  console.log(subcategory, seoFriendlySlug("X-Ray Baggage Scanner"));
  return (
    <>
      <Helmet>
        <title>{`${subcategory}`} | TimeWatch Infocom</title>
        <meta
          name="description"
          content={`Discover a range of specialized security solutions under ${subcategory} at TimeWatch Infocom.`}
        ></meta>
        <meta
          name="keywords"
          content={`${subcategory === seoFriendlySlug("X-Ray Baggage Scanner") ?  "baggage scanner, X-Ray Baggage Scanner" + baggageScannerKewords  : "baggage scanner, X-Ray Baggage Scanner" +baggageScannerKewords }`}
        />
        <link
          rel="canonical"
          href={`https://www.timewatchindia.com/market-place/${category}/${subcategory}`}
        ></link>
      </Helmet>
      <header className="navbar">
        <Navbar />
      </header>

      <div className="content-container">
        <section className="subCategory">
          <Subcategory />
        </section>
      </div>
      <footer className="footer">
        <Footer />
      </footer>
    </>
  );
};

export default SubCategoryPage;
